"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Time = /** @class */ (function () {
    function Time(hours, minutes, seconds, ampm) {
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.ampm = ampm;
    }
    Time.prototype.isEqual = function (anotherTime) {
        return anotherTime && this.hours === anotherTime.hours &&
            this.minutes === anotherTime.minutes &&
            this.seconds === anotherTime.seconds &&
            this.ampm === anotherTime.ampm;
    };
    return Time;
}());
exports.default = Time;
